import { APP_TIME_ZONE } from "@/utils/date";

export const ADMIN_TIME_ZONE = APP_TIME_ZONE;

const articleDateFormatter = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  timeZone: ADMIN_TIME_ZONE,
});

const weekdayFormatter = new Intl.DateTimeFormat("pt-BR", {
  weekday: "short",
  timeZone: ADMIN_TIME_ZONE,
});

const dayMonthFormatter = new Intl.DateTimeFormat("pt-BR", {
  day: "numeric",
  month: "numeric",
  timeZone: ADMIN_TIME_ZONE,
});

const monthDayFormatter = new Intl.DateTimeFormat("pt-BR", {
  month: "short",
  day: "numeric",
  timeZone: ADMIN_TIME_ZONE,
});

export function formatAdminArticleDate(date: Date = new Date()) {
  return articleDateFormatter.format(date);
}

export function formatAdminChartLabel(date: Date, days: number) {
  if (days <= 7) {
    return weekdayFormatter.format(date);
  }

  if (days <= 30) {
    return dayMonthFormatter.format(date);
  }

  return monthDayFormatter.format(date);
}